<template>
    <div>
        <!-- <div class="pop_open" @click="showModal">
            <div class="info_icon">
                <SvgHeaderSvg :type="'ask'" />
            </div>
        </div> -->

        <div >
            <Teleport  to="#teleports">
                <div class="modal fade" data-bs-backdrop="true" :id="`modal-${ringBox}`"  tabindex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-body modal-content">
                            <div class="">
                                <div class="title_block">
                                    <h3 class="mb-0 font-active">{{ title }}: <span> {{item.sub_type_1 ||item.sub_type || item.setting}}</span></h3>
                                    <span @click="notOpenModal">
                                        <SvgHeaderSvg type="close" class="largesvg"/>
                                    </span>
                                </div>
                            <div class="mt-3">
                                        <!-- CYO RING SETTING STYLES -->
                                        <div class="ring_box" v-if="(moduleSubType === 'ring' || type === 'preset') && (props.detailData?.sub_type !== 'in-stock-ring') && moduleSubType !== 'earring'">
                                            <!-- Box for CYO RING Style display from setting to complete for ring setting only -->
                                            <!-- Generice Content for Ring style -->
                                            <p class="mb-0">
                                                Style refers to the overall look and design of a ring. There are several ring styles to choose from, all offering a unique appearance. 
                                            </p>
                                            <br>
                                            <div class="image_block my-3 text-center">
                                                <img :src="'/settingactive/' + lowercase(item.sub_type) + '.svg'" width="115" height="72">
                                             <p class="title mb-0">{{item.sub_type }}</p>
                                            </div>
                                            <!-- Dynamic Content  -->
                                            <p class="mb-0" v-if="item.sub_type === 'halo'">A halo setting features smaller diamonds encircling the center stone, forming a halo effect that enhances its brilliance while making it appear larger.</p>
                                            <p class="mb-0" v-if="item.sub_type === 'solitaire'">A solitaire setting highlights the beauty of a single diamond, usually mounted on a simple band, showcasing its brilliance and elegance without distractions.</p>
                                            <p class="mb-0" v-if="item.sub_type === 'three-stone'">A three stone setting features three diamonds, often representing the past, present, and future, creating a balanced and meaningful design with added sparkle.</p>
                                            <p class="mb-0" v-if="item.sub_type === 'side-stone'">A side stone setting enhances the central stone with smaller stones on either side, adding extra brilliance and complementing the main gem's shine.</p>
                                            <p class="mb-0" v-if="item.sub_type === 'vintage'">A vintage setting is inspired by vintage charm, this setting features intricate detailing and classic design elements that offer a regal, classic look to celebrate bygone eras.</p>
                                            

                                        </div>
                                        <!-- Box for CYO Earring Style -->   
                                        <div class="earr_box" v-if="moduleSubType === 'earring'">
                                             <!-- Generice Content for CYO Earring Stylee -->
                                            <p>
                                                Earrings come in a variety of shapes, sizes, and styles. Each style offers a unique way to enhance a look, ranging from classy solitaire studs, to bold danglers. Whether you prefer a subtle sparkle or a standout design, there’s an earring style to suit all tastes. 
                                            </p>
                                            
                                            <div class="image_block my-3 text-center">
                                                <img 
                                                :width="moduleSubType === 'earring' || moduleSubType === 'pendant' ? '150' : '72'"
                                                :height="moduleSubType === 'earring' || moduleSubType === 'pendant' ? '150' : '72'"
                                                :src="'/settingactive/webshop/' + 
                                                      (moduleSubType === 'earring' 
                                                        ? 'e' + lowercase(item.sub_type) 
                                                        : moduleSubType === 'pendant' 
                                                        ? 'p' + lowercase(item.sub_type) 
                                                        : lowercase(item.sub_type)) + '.svg'" 
                                                alt="Style" 
                                              />

                                              <p class="title mb-0">{{item.sub_type }}</p>
                                            </div>

                                            <p class="mb-0" v-if="item.sub_type === 'dangle'">Dangle earrings hang below the earlobes, typically swinging or moving as you move. They come in a variety of lengths and styles and can be delicate or bold.</p>
                                            <p class="mb-0" v-if="item.sub_type === 'stud'">Stud earrings are small earrings that sit directly on the earlobe. Typically featuring a simple gemstone, they are secured with a post that passes through the ear and is held in place by a backing. </p>
                                            <p class="mb-0" v-if="item.sub_type === 'hoop'">Hoop earrings are circular or semi-circular earrings that loop around the earlobe. Available in various sizes, shapes and designs, they range from simple hoops to more elaborate designs.                                     </p>
                                        </div>
                                        <!-- box for pendant style -->
                                        <div class="pendant_box" v-if="moduleSubType === 'pendant'">
                                            <!-- Generice Content for for pendant style -->
                                            <p>A pendant is a piece of {{ $t('jewelry') }} that hangs from a chain, worn around the neck. Pendants come in a wide variety of styles, ranging from simple designs to intricate pieces. Whether you are looking for a subtle piece or something more loud, we have a pendant that will suit any occasion.</p>
                                            
                                            <div class="image_block my-3 text-center">
                                                <!-- <img width="150" height="72" :src="'/settingactive/webshop/' + lowercase(item.sub_type) + '.svg'"> -->
                                                <img 
                                                :width="moduleSubType === 'earring' || moduleSubType === 'pendant' ? '150' : '72'"
                                                :height="moduleSubType === 'earring' || moduleSubType === 'pendant' ? '150' : '72'"
                                                :src="'/settingactive/webshop/' + 
                                                      (moduleSubType === 'earring' 
                                                        ? 'e' + lowercase(item.sub_type) 
                                                        : moduleSubType === 'pendant' 
                                                        ? 'p' + lowercase(item.sub_type) 
                                                        : lowercase(item.sub_type)) + '.svg'" 
                                                alt="Style" 
                                              />

                                              <p class="title mb-0">{{item.sub_type }}</p>
                                            </div>
                                           
                                            <p class="mb-0" v-if="item.sub_type === 'halo'">Halo pendants feature a central diamond that is surrounded by a circle of smaller stones, creating a halo effect. This design makes the centerstone look larger and is an incredibly popular choice.</p>
                                            <p class="mb-0" v-if="item.sub_type === 'solitaire'">A solitaire pendant features a single, prominently displayed diamond set in a simple design. This is a classy and timeless choice. It can vary in size, and diamond shape. </p>
                                            <p class="mb-0" v-if="item.sub_type === 'lariat'">Lariat necklaces are designed with a long, open-ended chain that loops through or drapes around the neck. This style offers versatility and is adjustable.</p>
                                        </div>
                                        <!-- box for matching band style -->
                                        <div class="matching" v-if="props.detailData?.sub_type === 'band-ring' || props.detailData?.sub_type === 'anniversary-ring' ">
                                            <!--Generice Content for matching band style -->
                                            <p>Band styles can range from something as simple as a plain band to something bolder with accent diamonds. There are a variety of styles to choose from</p>
                                            
                                            <div class="image_block my-3 text-center" v-if="props.detailData?.sub_type_1">
                                                <img width="130" height="72" :src="'/settingactive/' + lowercase(props.detailData.sub_type_1) + '.svg'" alt="matching band">
                                                <p class="title mb-0">{{props.detailData?.sub_type_1 }}</p>
                                            </div>
                                            <p class="mb-0" v-if="item.sub_type_1 === 'seven-stone'">A band adorned with seven dazzling stones, each marking a special moment in your journey together.</p>
                                            <p class="mb-0" v-if="props.detailData?.sub_type_1 === 'plain'">A classic, unadorned band that offers timeless simplicity and understated elegance.</p>
                                            <p class="mb-0" v-if="props.detailData?.sub_type_1 === 'half-eternity'">A band adorned with diamonds halfway around, combining elegance with a touch of sparkle.</p>
                                            <p class="mb-0" v-if="props.detailData?.sub_type_1 === 'full-eternity'">A timeless design featuring diamonds encircling the entire band, symbolizing endless love and brilliance.</p>
                                            <p class="mb-0" v-if="props.detailData?.sub_type_1 === 'unique'">A distinctive band with a one-of-a-kind design, crafted to stand out and make a statement.</p>
                                            <p class="mb-0" v-if="props.detailData?.sub_type_1 === 'curve'">A gracefully curved band that fits seamlessly with other rings, adding a touch of unique sophistication.</p>
                                            <p class="mb-0" v-if="item.sub_type_1 === 'five-stone'">Five sparkling stones adorn this band, marking the key moments and cherished milestones of your relationship.</p>
                                            <p class="mb-0" v-if="item.sub_type_1 === 'two-stones'">Features two diamonds of different shapes that beautifully symbolize the union of two souls, with each diamond representing a unique connection. Set in a sleek band, this ring is the perfect representation of everlasting love and commitment. </p>
                                            <p class="mb-0" v-if="item.sub_type_1 === 'solitaire'">Highlights the beauty of a single gemstone, usually mounted on a simple band, showcasing its brilliance and elegance without distractions.</p>
                                            <p class="mb-0" v-if="item.sub_type_1 === 'eternity-ring'">A band featuring diamonds all around the band. The perfect ring for any ensemble. </p>
                                            <p class="mb-0" v-if="item.sub_type_1 === 'couple-bands'">Couple bands are matching his and her bands that are a symbol of two people’s shared love and commitment. </p>
                                         
                                        </div>
                                        <!-- seperate solo content-->
                                        <div class="solo_box" v-if="props.detailData?.sub_type !== 'band-ring' && props.item?.sub_type === 'in-stock-ring'">

                                            <!-- Generice Content for two stone -->
                                            
                                            <div class="image_block my-3 text-center" v-if="item.sub_type_1">
                                                <img :src="'/settingactive/' + lowercase(item.sub_type_1) + '.svg'">
                                                <p class="title mb-0">{{item.sub_type_1 }}</p>
                                            </div>
                                            <p class="mb-0" v-if="item.sub_type_1 === 'two-stones'">Features two diamonds of different shapes that beautifully symbolize the union of two souls, with each diamond representing a unique connection. Set in a sleek band, this ring is the perfect representation of everlasting love and commitment. </p>
                                            <p class="mb-0" v-if="item.sub_type_1 === 'solitaire'">Highlights the beauty of a single gemstone, usually mounted on a simple band, showcasing its brilliance and elegance without distractions.</p>
                                            <p class="mb-0" v-if="item.sub_type_1 === 'eternity-ring'">A band featuring diamonds all around the band. The perfect ring for any ensemble. </p>
                                            <p class="mb-0" v-if="item.sub_type_1 === 'couple-bands'">Couple bands are matching his and her bands that are a symbol of two people’s shared love and commitment. </p>
                                         
                                            <p class="mb-0" v-if="item.sub_type_1 === 'five-stone'">Five sparkling stones adorn this band, marking the key moments and cherished milestones of your relationship.</p>
                                            <p class="mb-0" v-if="item.sub_type_1 === 'halo'">Smaller diamonds encircle the center stone, forming a halo effect that enhances its brilliance while making it appear larger.</p>
                                            <p class="mb-0" v-if="item.sub_type_1 === 'three-stone'">Features three gemstones, often representing the past, present, and future, creating a balanced and meaningful design with added sparkle.</p>
                                            <p class="mb-0" v-if="item.sub_type_1 === 'side-stone'">Enhances the central stone with smaller stones on either side, adding extra brilliance and complementing the main gem's shine.</p>
                                            <p class="mb-0" v-if="item.sub_type_1 === 'vintage'">Inspired by vintage charm, this ring features intricate detailing and classic design elements that offer a regal, classic look to celebrate bygone eras.</p>
                                        </div>
 
                                            <!-- <p class="mb-0" v-if="item === 'classic'">lorem ipsum</p> -->
                            </div>
                        </div>

                        </div>
                    </div>
                </div>
            </Teleport>    
        </div>

    </div>
</template>

<script setup>
    const flagShowModal = ref(false);
    const style = ref(null);
    const props = defineProps(['item','title','moduleSubType','detailData','type','ringBox'])

    const active = ref(props.ringBox)
    const notOpenModal = () => {
        emit('close');
        active.value = null;
    };
    const emit = defineEmits(['close']);
 

    const showModal = () => {
        flagShowModal.value = true;
        nextTick(() => {
            const modalElement = style.value;
            if (modalElement) {
                const modalInstance = new bootstrap.Modal(modalElement);
                modalInstance.show();
            }
        });
    };

    const hideModal = () => {
        const modalElement = style.value;
        if (modalElement) {
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
        flagShowModal.value = false;
    };

    const lowercase = (value) => {
        return value.toLowerCase().replace(/[^\w\s]/gi, '');
    }  
//     const lowercase = (value) => {
//     if (!value) return '';
//     return value.toLowerCase().replace(/[^\w\s]/gi, '');
// }
// const lowercase = (value) => {
//     if (!value) return '';
//     return value.toLowerCase().replace(/[^\w\s-]/gi, '');
// }


</script>



<style scoped>
.largesvg {
    transform: scale(1.3);
}
.img_box {
    height: 130px;
}

.pop_open {
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}

.title_block {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
}


p {
    font-size: 16px;
    color: #606060;
}

.title_block span {
    cursor: pointer;
    color: var(--green);
}

h3 {
    font-size: 22px;
}

.m-info {
    margin: 10px 0;
}
.image_block{
    text-align: center;
}
.title{
    text-transform: capitalize;
    color: #668b84;
    font-size: 16px;

}
@media(max-width: 767px) {
    h3 {
        font-size: 20px;
    }
    p {
        font-size: 14px;
    }

    .acc_box {
        min-width: 60px;
        font-size: 14px;
        padding: 3px 8px;
    }
}
</style>
